import React , { Fragment  } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import './ShowImageModal.css';


const ShowImageModal = ({openModal , setOpenModal}) => {
    return(
        <Fragment>
        <Modal
        className="show-image-modal"
        wrapClassName="modal-dialog"
        contentClassName="modal-dialog"
        isOpen={openModal}
        toggle={() => setOpenModal(false)}
    >
        <ModalHeader className="modal-header">
            <div style={{ justifyContent: 'space-between', width: '100%' }} className="flex">
                <div className="modal-title">
                    Image must be 468x60 or 160x600
                </div>
                <button 
                    onClick={() => setOpenModal(false)} 
                    className="close-button"
                >
                    <CloseIcon />
                </button>
            </div>
        </ModalHeader>
        <ModalBody>
            <button 
                className="ok-button" 
                onClick={()=>setOpenModal(false)}
            >
                OK
            </button>
        </ModalBody>
        </Modal>
</Fragment>
    )
}
export default ShowImageModal